export default __webpack_public_path__ + "static/media/slider-img2-1-1.60ba5f8c.png";